export default "__VITE_ASSET__09RuOXFd__"